import { render, staticRenderFns } from "./BlogSubcategoryList.vue?vue&type=template&id=3147fd19&"
import script from "./BlogSubcategoryList.vue?vue&type=script&lang=js&"
export * from "./BlogSubcategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports